
import api from './api';

const NOTIFICATIONS_BASE = '/notifications';


export const registerDevice = async (fcmToken, deviceType = 'web') => {
  try {
    const response = await api.post(`${NOTIFICATIONS_BASE}/register-device`, {
      fcm_token: fcmToken,
      device_type: deviceType,
    });
    console.log('[NotificationService] Device registered successfully');
    return response.data;
  } catch (error) {
    console.error('[NotificationService] Failed to register device:', error);
    throw error;
  }
};


export const unregisterDevice = async (fcmToken) => {
  try {
    const response = await api.delete(`${NOTIFICATIONS_BASE}/unregister-device`, {
      data: { fcm_token: fcmToken },
    });
    console.log('[NotificationService] Device unregistered successfully');
    return response.data;
  } catch (error) {
    console.error('[NotificationService] Failed to unregister device:', error);
    throw error;
  }
};


export const getNotifications = async (params = {}) => {
  try {
    const queryParams = {
      pageNumber: params.pageNumber ?? 0,
      pageSize: params.pageSize ?? 20,
    };

    if (params.is_read !== undefined) {
      queryParams.is_read = params.is_read;
    }
    if (params.type) {
      queryParams.type = params.type;
    }

    const response = await api.get(NOTIFICATIONS_BASE, { params: queryParams });
    return response.data;
  } catch (error) {
    console.error('[NotificationService] Failed to fetch notifications:', error);
    throw error;
  }
};

export const getUnreadCount = async () => {
  try {
    const response = await api.get(`${NOTIFICATIONS_BASE}/unread-count`);
    return response.data;
  } catch (error) {
    console.error('[NotificationService] Failed to fetch unread count:', error);
    throw error;
  }
};


export const markAsRead = async (notificationId) => {
  try {
    const response = await api.put(`${NOTIFICATIONS_BASE}/${notificationId}/read`);
    console.log('[NotificationService] Notification marked as read:', notificationId);
    return response.data;
  } catch (error) {
    console.error('[NotificationService] Failed to mark notification as read:', error);
    throw error;
  }
};


export const markAllAsRead = async () => {
  try {
    const response = await api.put(`${NOTIFICATIONS_BASE}/mark-all-read`);
    console.log('[NotificationService] All notifications marked as read');
    return response.data;
  } catch (error) {
    console.error('[NotificationService] Failed to mark all as read:', error);
    throw error;
  }
};


export const NOTIFICATION_TYPES = {
  ORDER_PLACED: 'ORDER_PLACED',
  ORDER_STATUS_CHANGED: 'ORDER_STATUS_CHANGED',
  ORDER_DELIVERED: 'ORDER_DELIVERED',
  ORDER_CANCELLED: 'ORDER_CANCELLED',
  PAYMENT_RECEIVED: 'PAYMENT_RECEIVED',
};


export const getNotificationTypeInfo = (type) => {
  const typeInfo = {
    [NOTIFICATION_TYPES.ORDER_PLACED]: {
      icon: 'pi-shopping-cart',
      color: '#4caf50',
      label: 'Order Placed',
    },
    [NOTIFICATION_TYPES.ORDER_STATUS_CHANGED]: {
      icon: 'pi-refresh',
      color: '#2196f3',
      label: 'Status Changed',
    },
    [NOTIFICATION_TYPES.ORDER_DELIVERED]: {
      icon: 'pi-check-circle',
      color: '#8bc34a',
      label: 'Order Delivered',
    },
    [NOTIFICATION_TYPES.ORDER_CANCELLED]: {
      icon: 'pi-times-circle',
      color: '#f44336',
      label: 'Order Cancelled',
    },
    [NOTIFICATION_TYPES.PAYMENT_RECEIVED]: {
      icon: 'pi-dollar',
      color: '#ff9800',
      label: 'Payment Received',
    },
  };

  return typeInfo[type] || {
    icon: 'pi-bell',
    color: '#9e9e9e',
    label: 'Notification',
  };
};
